// 菜单配置数据
export const menuList = [
	{
		path: '/admin/unitNum',
		name: 'UnitNum',
		title: '单位限额配置',
		icon: 'el-icon-s-home',
		component: () => import('@/views/admin/views/unitNum.vue'),
		meta: { name: '单位限额配置' }
	},
	{
		path: '/admin/commissionWithdraw',
		name: 'CommissionWithdraw',
		title: '佣金提现管理',
		icon: 'el-icon-money',
		component: () => import('@/views/admin/views/commissionWithdraw.vue'),
		meta: { name: '佣金提现管理' }
	},
	{
		path: '/admin/invitationCodeStatistics',
		name: 'InvitationCodeStatistics',
		title: '邀请码统计',
		icon: 'el-icon-data-line',
		component: () => import('@/views/admin/views/invitationCodeStatistics.vue'),
		meta: { name: '邀请码统计' }
	},
	{
		path: '/admin/freeExchangeCode',
		name: 'FreeExchangeCode',
		title: '生成兑换码',
		icon: 'el-icon-present',
		component: () => import('@/views/admin/views/freeExchangeCode.vue'),
		meta: { name: '生成兑换码' }
	},
	{
		path: '/admin/redeemRecord',
		name: 'RedeemRecord',
		title: '兑换码统计',
		icon: 'el-icon-document-copy',
		component: () => import('@/views/admin/views/redeemRecord.vue'),
		meta: { name: '兑换码记录统计' }
	},	{
        path: '/admin/lecturerManage',
        name: 'LecturerManage',
        title: '讲师招募管理',
        icon: 'el-icon-user',
        component: () => import('@/views/admin/views/lecturerManage.vue'),
        meta: { name: '讲师招募管理' }
    },
	{
		path: '/admin/usageStatistics',
		name: 'UsageStatistics',
		title: '使用量统计',
		icon: 'el-icon-data-analysis',
		component: () => import('@/views/admin/views/usageStatistics.vue'),
		meta: { name: '使用量统计' }
	},
]
